import React from 'react';
export const Footer = () => {
  return <footer className="bg-text-dark text-cream/60 py-12 text-center text-sm" data-id="element-85">
      <div className="max-w-4xl mx-auto px-6" data-id="element-86">
        <p className="mb-4 font-serif text-xl text-cream" data-id="element-87">
          Método Emprendimiento Aesthetic™
        </p>
        <p className="mb-6" data-id="element-88">Transformando la vida de mujeres emprendedoras.</p>
        <div className="flex justify-center gap-6 mb-8" data-id="element-89">
          <a href="#" className="hover:text-cream transition-colors" data-id="element-90">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-91">
            Políticas de Privacidad
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-92">
            Contacto
          </a>
        </div>
        <p data-id="element-93">
          © {new Date().getFullYear()} Método Emprendimiento Aesthetic. Todos
          los derechos reservados.
        </p>
        <p className="mt-2 text-xs opacity-50" data-id="element-94">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </div>
    </footer>;
};